import Tab from "components/Tab";
import UploadSymbolSetsPlatforms from "../../../../contents/docs/error-tracking/_snippets/upload-symbol-sets-platforms.tsx";
import * as React from 'react';
export default {
  Tab,
  UploadSymbolSetsPlatforms,
  React
};